jQuery('.contact-us-link').click(function(){
  jQuery('#myModal1').modal('show');
});

jQuery('#myModal1').on('show.bs.modal', function (e) {
    console.log('modal show');
});

jQuery('#myModal1').on('hidden.bs.modal', function (e) {
    console.log('modal hide');
});

// add auto-scrolling to find-a-store page - linked to store-locator.js in plugins
function goToWithScroll(a) {
		jQuery("html, body").animate({
		scrollTop: jQuery(a).offset().top + "px"
		});
	}

function getGaTracking(param_zip){
	console.log(param_zip);
	zip_code = param_zip;
	__gaTracker('send', 'event', 'Store-locator', 'Address Submitted', zip_code);
}

// __gaTracker('send', {
//   hitType: 'event',
//   eventCategory: 'Store-locator',
//   eventAction: 'Address Submitted',
//   eventLabel: 'Results Found',
//   eventValue: param_zip,
// });

// function getGaTracking(zip_code) {
// 	__gaTracker('send', {
// 	  hitType: 'event',
// 	  eventCategory: 'Store-locator',
// 	  eventAction: 'Address Submitted',
// 	  eventLabel: zip_code,
// 	  eventValue: ''
// 	});
// }

//facebook share
function fbShare() {
//ga('send', 'event', 'App Clicks', 'Share Clicks', "Facebook");
var name_var = "Help Us Find A Cure to Cystic Fibrosis!";
var message_var = "Messager var";
var picture_var = "http://mint-x.com/wp-content/themes/mintx/dist/images/mornings/mintx-mornings-fb-share.jpg";
var share_link_var = "http://bit.ly/MintXMornings2016";
var description_var = "We'll donate $1 for ever photo shared with the hashtag #mintxmornings and you'll get entered for a chance to win awesome prizes!";
var user_message_prompt_var = "user message prompt";
FB.ui({
method: 'feed',
message: message_var,
name: name_var,
caption: '',
description: ( description_var ),
link: share_link_var,
picture: picture_var,
actions: [
{ name: name_var, link: share_link_var }
],
user_message_prompt: user_message_prompt_var
},
function(response) {
if (response && response.post_id) {
//ga('send', 'event', 'App Clicks', 'Share Clicks', "Successfully posted to facebook wall");
}
else {

}
}
);
}

function twShare() {
//ga('send', 'event', 'App Clicks', 'Share Clicks', "Twitter");
var fullMessage = "Enter to #win a month’s supply of @MintXTrashBags and support Cystic Fibrosis" + " http://bit.ly/MintXMornings2016";
window.open('http://twitter.com/intent/tweet?text=' + encodeURIComponent(fullMessage));
}

